<template>
    <form @keyup.enter="loginOrquestra">
        <div id="containerLogin">
            <div class="form-group">
                <label for="login" id="containerLoginLabel">{{labelLogin}}</label>
                <input type="text" v-model="username" class="form-control" maxlength="64" id="login" />
            </div>

            <div class="form-group mb-5">
                <label for="password">{{$t("password")}}</label>
                <input type="password" v-model="password" class="form-control" maxlength="64" id="password" />
                <button type="button" class="btn btn-sm btn-link text-primary p-0 mt-2 float-right" id="btnRememberPassword" @click.prevent="recoverPassword">{{$t("forgotMyPassword")}}</button>
            </div>

            <div class="form-group custom-control custom-checkbox d-lg-block mt-3" v-show="isMobile">
                <input type="checkbox" v-model="persist" class="custom-control-input" id="persist">
                <label class="custom-control-label" for="persist">{{$t("saveInformation")}}</label>
            </div>

            <button type="button" id="btnLogin" class="btn btn-primary btn-block btn-lg" @click.prevent="loginOrquestra" :disabled="isLoading">
                <span v-show="!isLoading">{{$t("login")}}</span>
                <div class="spinner text-light" v-show="isLoading"></div>
            </button>
        </div>
    </form>
</template>
<script>
    import SharedMixin from './../../mixins/SharedMethods'
    export default {
        name: 'TheContainerLogin',
        data() {
            return {
                username: "",
                password: "",
                persist: true,
                isLoading: false
            }
        },
        computed: {
            labelLogin: function () { return this.$t('labeluser') },
            isMobile: function () {
                return !this.isRenderMobile();
            }
        },
        watch: {
            'persist': function (val) {
                this.$store.commit("CHANGE_LOGIN_PERSIST", val);
            }
        },
        mixins: [SharedMixin],
        methods: {
            loginOrquestra: function () {
                let self = this;
                this.isLoading = true
                if (this.username == '' || this.password == '') {
                    self.showAlert("badrequest", "danger")
                    return;
                }
                let origin = this.$store.state.origin;
                let codSystem = this.$store.state.codSystem;

                const baseURI = `Authentication/V1/Login/?origin=${origin}&codSystem=${codSystem}`;

                let data = {
                    user: self.username,
                    password: self.password,
                    persist: self.persist,
                    integrationName: self.$store.state.integrationName
                };

                this.$http.post(baseURI, data)
                    .then(result => {
                        const authenticationResult = result.data.authenticationResult.toUpperCase();
                        if (authenticationResult === "SUCCESS" || authenticationResult === "MUSTCHANGEPASSWORD") {
                            window.top.location.href = `${origin}/api/internal/services/2.0/authentication/login?${result.data.result}&urlRedirect=${self.$store.state.urlRedirect}&lang=${self.$store.state.localization}&CodMobileAppCrypt=${self.$store.state.appCode}`;
                        } else if (authenticationResult === "EXTERNALAUTHENTICATIONONLY") {
                            self.showAlert(result.data.authenticationResult, "warning");
                        } else {
                            self.showAlert(result.data.authenticationResult, "danger");
                        }
                    }, (error) => {
                        console.log(error);
                    });
            },
            recoverPassword: function () {
                let self = this;

                if (this.username == '') {
                    self.showAlert("userfieldrequerid", "danger")
                    return;
                }

                const origin = self.$store.state.origin;
                const baseURI = `Authentication/V1/RecoverPassword/?origin=${origin}&username=${self.username}`;
                let message = "msgrememberpasswordsuccess";
                let type = "success";

                this.$http.get(baseURI)
                    .then(function ({ data }) {
                        const result = data.result?.toUpperCase();
                        if (!data.success && result === "EXTERNALAUTHENTICATIONONLY") {
                            message = result;
                            type = "warning";
                        }
                    })
                    .finally(function () {
                        self.showAlert(message, type);
                    });
            }
        }
    }
</script>